import { useUserActiveOrganization, useInboundSubscriptions } from "@/api";
import { inboundSubscriptionColumns } from "../../assets/SubscriptionColumns";
import { useInboundSubscriptionTableData } from "../../hooks/useSubscriptionTableData";
import { SubscriptionsTable } from "./SubscriptionsTable";

interface Props {
  filterInactive: boolean;
}

const InboundSubscriptionTable = ({ filterInactive }: Props) => {
  const { activeOrganization } = useUserActiveOrganization();
  const { data, loading, error } = useInboundSubscriptions({
    organizationSlug: activeOrganization?.slug
  });
  const tableData = useInboundSubscriptionTableData(data, filterInactive);

  return (
    <SubscriptionsTable
      data={tableData}
      loading={loading}
      error={error}
      columns={inboundSubscriptionColumns}
    />
  );
};

export default InboundSubscriptionTable;
